import React, { useState } from 'react';
import { makeStyles, Theme } from '@material-ui/core/styles';
import ExclamationMark from 'components/icons/ExclamationMark';
import { ConnectSystemError } from 'components/onboarding/ConnectSystemError';
import {
  ConnectFinch,
  ConnectPayrollDisplayProps,
} from 'components/ConnectFinch';
import { ImportType } from '../../../../../lib/interfaces';
import { Button, Color, Flex, Text } from 'component-library';
import { FINCH_PAYROLL_SYSTEMS } from 'lib/constants';
import { PayrollFileUploader } from './components/PayrollFileUploader';
import { useFeatureFlags } from 'stores/useStores';

const useStyles = makeStyles(({ copper }: Theme) => ({
  root: {
    color: copper,
    display: 'flex',
    alignItems: 'center',
    fontSize: '18px',
    fontWeight: 500,
  },
  icon: {
    marginRight: '10px',
  },
}));

const ConnectFinchDisplay = ({
  openFinch,
  loading,
  finchError,
}: ConnectPayrollDisplayProps) => {
  return (
    <>
      <Button
        label='Reconnect'
        onClick={openFinch}
        loading={loading}
        flexAlignSelf='flex-start'
      />
      {finchError && <ConnectSystemError systemType='payroll' />}
    </>
  );
};

export interface ExpiredTokenMessageProps {
  service: string;
  onPayrollConnected: () => Promise<void>;
  importType: ImportType;
  taxYear?: number;
}

export const ExpiredTokenMessage = ({
  service,
  onPayrollConnected,
  importType,
  taxYear,
}: ExpiredTokenMessageProps) => {
  const classes = useStyles();
  const featureFlags = useFeatureFlags();
  const [, setDoThisLaterModal] = useState(false);

  // Check if this provider requires manual file upload instead of Finch Connect
  const payrollConfig = FINCH_PAYROLL_SYSTEMS.find(
    (system) => system.id === service?.toLowerCase(),
  );
  const isManualProvider =
    service === 'rippling' || payrollConfig?.manual === true;

  const payrollYear = featureFlags.currentProcessingTaxYear;

  return (
    <Flex direction='column' gap={24}>
      <Flex gap={4}>
        <ExclamationMark className={classes.icon} />
        <Text size={18} color={Color.semantic.$error50}>
          Payroll connection issue
        </Text>
      </Flex>
      {isManualProvider ? (
        <PayrollFileUploader
          payrollYear={payrollYear}
          submitManualPayroll={onPayrollConnected}
          payrollSystem={payrollConfig || null}
          setDoThisLaterModal={setDoThisLaterModal}
          skipThisStep={false}
          importType={importType}
          partner={service}
          taxYear={taxYear}
        />
      ) : (
        <ConnectFinch
          onPayrollConnected={onPayrollConnected}
          connectPayrollDisplay={ConnectFinchDisplay}
          payrollSystem={service ? service : undefined}
          importType={importType}
          taxYear={taxYear}
        />
      )}
    </Flex>
  );
};
